import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/shop/layout.tsx");
